import { FC } from 'react';
import classNames from 'classnames';
import { ENV_CONFIG } from 'config/environment';

interface Props {
  name: string;
  title: string;
  imgID?: string;
  recID?: string;
  isRecipient?: boolean;
  isNew?: boolean;
}

export const Member: FC<Props> = ({
  name,
  title,
  imgID = 'recipient_default',
  recID,
  isRecipient,
  isNew = false, // TODO: remove this when facelift is finished
}) => {
  return (
    <div className="our-team-members-container">
      <img
        alt="Recipient headshot"
        className={classNames({ 'is-new': isNew })}
        src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/${
          isRecipient && recID
            ? `recipients/rec_${recID}.jpg`
            : `headshots/${imgID.toLowerCase()}.jpeg`
        }`}
      />
      <span className={classNames('body-text name', { 'is-new': isNew })}>{name}</span>
      <span className={classNames('eyebrow-text', { 'is-new': isNew })}>{title}</span>
    </div>
  );
};
